import React from 'react';
import { Colors, LoadingSpinner } from 'library';
import { Card, styled } from '@mui/material';

import { Notifications } from './Notifications';
import { PaymentSetup } from './PaymentSetup';

import type { DashboardSummary } from '../types';

export function NotificationsAndPayments({
    data,
    loading,
    error,
    small,
}: {
    data?: DashboardSummary;
    loading: boolean;
    error: boolean;
    small: boolean;
}) {
    if (error || !data) return null;

    return (
        <StyledCard small={small.toString()}>
            <CardBody>
                {loading && <LoadingSpinner loadingStyle={{ color: Colors.darkNavy }} />}
                {!loading &&
                    (data?.payment?.status === 'complete' ? (
                        <Notifications data={data} />
                    ) : (
                        <PaymentSetup status={data?.payment?.status} />
                    ))}
            </CardBody>
        </StyledCard>
    );
}

const StyledCard = styled(Card)(({ small }: { small: string }) => ({
    backgroundColor: Colors.white,
    borderRadius: 10,
    marginLeft: small === 'true' ? 0 : 20,
    marginTop: small === 'true' ? 20 : 0,
    padding: 20,
    width: small === 'true' ? '100%' : '45%',
}));

const CardBody = styled('div')({
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
});
